import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useRef } from 'react';
import { getCategoryTotals } from 'actions';
import { selectHasSetPaydayRange } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { format, parseISO } from 'date-fns';
import { selectCurrentMonthlyTotals, selectHasPendingCategoryEdits, } from '../selectors';
const useSyncTotals = (params) => {
    const { categoryId, merchantId, accountIds, step, runOnMount } = params || {};
    const hasPaydayRange = useAppSelector(selectHasSetPaydayRange);
    const dispatch = useAppDispatch();
    const hasMounted = useRef(false);
    const monthlyTotals = useAppSelector(selectCurrentMonthlyTotals);
    const totalsToDate = monthlyTotals[0]?.to;
    const totalsFromDate = monthlyTotals[monthlyTotals.length - 1]?.from;
    const hasPendingCategoryEdits = useAppSelector(selectHasPendingCategoryEdits);
    const id = categoryId ?? merchantId;
    useFocusEffect(useCallback(() => {
        if (!totalsFromDate ||
            !totalsToDate ||
            id == null ||
            hasPendingCategoryEdits ||
            (!runOnMount && !hasMounted.current)) {
            return;
        }
        dispatch(getCategoryTotals({
            dateFrom: format(parseISO(totalsFromDate), 'yyyy-MM-dd'),
            dateTo: format(parseISO(totalsToDate), 'yyyy-MM-dd'),
            categoryId,
            merchantId,
            isPayDay: hasPaydayRange,
            step,
            accountIds,
        }));
    }, [
        accountIds,
        categoryId,
        totalsFromDate,
        totalsToDate,
        hasPaydayRange,
        hasPendingCategoryEdits,
        id,
        merchantId,
        step,
        runOnMount,
    ]));
    useEffect(() => {
        hasMounted.current = true;
    }, []);
};
export default useSyncTotals;
